import { env } from '@/lib/runtime-env'

const getLegacyWorldsDomains = () =>
  (env('NEXT_PUBLIC_LEGACY_WORLDS_DOMAINS') || '').split(',').filter(Boolean)

export const WHITE_LIST = ['localhost', 'localhost.viverse.com', ...getLegacyWorldsDomains()]

export const LOCAL_ORIGIN = 'https://localhost.viverse.com:3000'

export const DEFAULT_VIVERSE_ORIGIN = 'https://www.viverse.com'
